import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { Layer } from "../../framework/layer/Layer";
import { ReplicatedObjectEvent } from "../common/ReplicatedObjectView";
export class GameContextListener extends Layer {
    constructor(gameContext, contextKeys) {
        super([]);
        this.isActiveSetter = undefined;
        this.revisionRef = { current: 0 };
        this.GameContextProviders = (props) => {
            const { children, fallback } = props;
            const [isActive, setIsActive] = useState(false);
            if (this.isActiveSetter !== setIsActive) {
                this.isActiveSetter = setIsActive;
            }
            const currentContextValues = Object.create(null);
            const gameContextData = this.gameContext.data;
            for (const key of this.contextKeys) {
                const [contextValue, setContextValue] = useState(() => {
                    const createdEvent = new ReplicatedObjectEvent(gameContextData[key] !== undefined);
                    this.setRevision(createdEvent);
                    return {
                        current: gameContextData[key], createdEvent,
                        deletedEvent: new ReplicatedObjectEvent(false)
                    };
                });
                if (this.contextSetters[key] !== setContextValue) {
                    this.contextSetters[key] = setContextValue;
                }
                currentContextValues[key] = contextValue;
            }
            if (!isActive) {
                return fallback;
            }
            const childrenWithProviders = this.contextKeys.reduce((children, key) => {
                const Provider = this.contextProviders[key].Provider;
                return _jsx(Provider, { value: currentContextValues[key], children: children });
            }, children);
            return childrenWithProviders;
        };
        this.gameContext = gameContext;
        this.contextKeys = contextKeys;
        this.contextProviders = Object.create(null);
        this.contextSetters = Object.create(null);
        for (const key of this.contextKeys) {
            this.contextProviders[key] = createContext(null);
        }
    }
    useGameContext(key) {
        return useContext(this.contextProviders[key]).current;
    }
    useCreatedEvent(key) {
        return useContext(this.contextProviders[key]).createdEvent;
    }
    useDeletedEvent(key) {
        return useContext(this.contextProviders[key]).deletedEvent;
    }
    // Need to update this because it activates before render happens.
    // (need one-time cached starting state to pass on)
    activate() {
        var _a, _b, _c;
        this.advanceRevisionRef();
        (_a = this.isActiveSetter) === null || _a === void 0 ? void 0 : _a.call(this, true);
        const gameContextData = this.gameContext.data;
        for (const key of Object.keys(gameContextData)) {
            const createdEvent = new ReplicatedObjectEvent(true);
            const deletedEvent = new ReplicatedObjectEvent(false);
            this.setRevision(createdEvent);
            this.setRevision(deletedEvent);
            (_c = (_b = this.contextSetters)[key]) === null || _c === void 0 ? void 0 : _c.call(_b, { current: gameContextData[key], createdEvent, deletedEvent });
        }
    }
    update(inEvent) {
        this.advanceRevisionRef();
        if (inEvent.type === 'Created' || inEvent.type === 'Updated') {
            // Set revision for any ReplicatedObjectEvent in the new data.
            if (typeof inEvent.newData === 'object') {
                for (const key of Object.keys(inEvent.newData)) {
                    const value = inEvent.newData[key];
                    if (typeof (value) === 'object' && value !== null && 'setRevision' in value) {
                        this.setRevision(value);
                    }
                }
            }
            console.log(`CreatedEvent for ${typeof (inEvent.newData) === 'object' && 'className' in inEvent.newData ? inEvent.newData.className : undefined}: ${inEvent.type === 'Created'}`);
            const createdEvent = new ReplicatedObjectEvent(inEvent.type === 'Created');
            const deletedEvent = new ReplicatedObjectEvent(false);
            this.setRevision(createdEvent);
            this.setRevision(deletedEvent);
            this.contextSetters[inEvent.key]({ current: inEvent.newData, createdEvent, deletedEvent });
        }
        else {
            const createdEvent = new ReplicatedObjectEvent(false);
            const deletedEvent = new ReplicatedObjectEvent(true);
            this.setRevision(createdEvent);
            this.setRevision(deletedEvent);
            this.contextSetters[inEvent.key]({ current: undefined, createdEvent, deletedEvent });
        }
        return null;
    }
    advanceRevisionRef() {
        this.revisionRef.current = (this.revisionRef.current + 1) % 10000;
    }
    setRevision(event) {
        event.setRevision(this.revisionRef);
    }
    close() {
        var _a;
        (_a = this.isActiveSetter) === null || _a === void 0 ? void 0 : _a.call(this, false);
    }
    getLayerData() {
        return null;
    }
}
//# sourceMappingURL=GameContextListener.js.map